import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CopyOutlineSVG = function CopyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.9 24H13.1a2.1 2.1 0 01-2.1-2.1V4.1A2.1 2.1 0 0113.1 2h13.8A2.1 2.1 0 0129 4.1v17.8a2.1 2.1 0 01-2.1 2.1zm0-19.9H13.1v17.8h13.8zM7 27.94l3 .01V30H7.06A2.06 2.06 0 015 27.94V25h2.01zM16 27.98V30h-4v-2.04l4 .02zM20.94 28l.06-2h2v1.94A2.06 2.06 0 0120.94 30H18v-2.01zM5 12.06A2.06 2.06 0 017.06 10H9v2H7.06l-.01 3H5zM7.04 17l-.02 6H5v-6h2.04z"
  }));
};
CopyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CopyOutlineSVG);